'use strict';

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid').removeAttr('aria-invalid');
}

module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();

    if (typeof payload === 'object' && payload.fields) {
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                var feedbackElement = $(formElement).find('[name="' + key + '"]')
                    .parent()
                    .children('.invalid-feedback');

                if (feedbackElement.length > 0) {
                    if (Array.isArray(payload[key])) {
                        feedbackElement.html(payload.fields[key].join('<br/>'));
                    } else {
                        feedbackElement.html(payload.fields[key]);
                    }
                    feedbackElement.show();
                    feedbackElement.siblings('.form-control').addClass('is-invalid').attr('aria-invalid','true');
                }

                if (key === 'dwfrm_profile_customer_birthday') {
                    var $inputBirthday = $(formElement).find('[id="registration-form-birthday-type"], [id="registration-form-birthday-type-login"]');
                    $inputBirthday.parents('.form-group').find('.invalid-years').text(payload.fields[key]).addClass('d-block').removeClass('d-none');
                    $inputBirthday.parents('.form-group').find('#registration-form-birthday').addClass('is-invalid').attr('aria-invalid', 'true');
                    $inputBirthday.removeClass('valid').addClass('invalid');
                    $inputBirthday.closest('form').find('.is-invalid').first().focus();
                }
            }
        });
    }
    if (payload && payload.error) {
        var form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');

        form.prepend('<div class="alert alert-danger" role="alert">'
            + payload.error.join('<br/>') + '</div>');
    }
};
